<template>
    <div>
        <el-row>
            <el-col :span="24" style="text-align: center;">
                <el-button type="primary" @click="print_query">打印订单</el-button>
            </el-col>
        </el-row>
        <el-card id="printMe">
            <div style="text-align: center;font-size:30px;height: 100px;padding-top: 60px;" class="print-only">{{
                qiyeName }}结算单</div>

            <div>
                <div class="title">
                    <!-- <div class="test"> test</div> -->
                    <span style="font-size: large;">
                        车辆信息
                    </span>
                    <!-- <el-col :span="4">
                        <el-button type="primary" @click="handleExport()" v-if="false">导出电子表格</el-button>
                    </el-col> -->
                </div>
                <div class="print-only">
                    --------------------------------------------------------------------------------------------------------
                </div>
                <div class="cheliang">
                    <div class="row" style="display: flex;flex-direction: row;">
                        <span style="width: 80px;min-width: 80px;">
                            <div class="grid-content bg-purple">车牌:</div>
                        </span>
                        <span style="min-width: 300px;">
                            <div class="grid-content bg-purple-light"><span>{{ cheliang_info.paizhao }}</span></div>
                        </span>
                        <span style="width: 80px;min-width: 80px;">
                            <div class="grid-content bg-purple">颜色:</div>
                        </span>
                        <span style="min-width: 300px;">
                            <div class="grid-content bg-purple-light">{{ cheliang_info.color }}</div>
                        </span>
                    </div>
                    <div class="row" style="display: flex;flex-direction: row;">
                        <span style="width: 180px;min-width: 180px;">
                            <span class="grid-content bg-purple">型号:</span>
                        </span>
                        <span style="width: 700px;">
                            <span class="grid-content bg-purple-light" style="width: 500px;">
                                {{ cheliang_info.chexing01 }}:{{ cheliang_info.chexing02 }}:{{ cheliang_info.chexing03
                                }}:{{
                cheliang_info.chexing04 }}
                            </span>
                        </span>
                    </div>

                </div>

            </div>

            <div style="width: 100%;">
                <div class="title" style="margin-top: 50px;">外观描述</div>
                <div class="print-only">
                    --------------------------------------------------------------------------------------------------------
                </div>
                <div class="waiguan" style="display: flex;flex-direction: row;">
                    <span>
                        <div class="grid-content bg-purple" style="width: 80px;min-width: 80px;">外观:</div>
                    </span>
                    <span>
                        <div class="grid-content bg-purple-light"><span>{{ waiguan_info.waiguan_memo }}</span></div>
                    </span>
                    <span>
                        <div class="grid-content bg-purple"> </div>
                    </span>
                    <span>
                        <div class="grid-content  "></div>
                    </span>
                    <span>
                        <div class="grid-content bg-purple"> </div>
                    </span>

                </div>
            </div>

            <div style="width: 100%; margin-top: 5px;">
                <div class="title" style="margin-top: 50px;">客户信息</div>
                <div class="print-only">
                    --------------------------------------------------------------------------------------------------------
                </div>
                <div class="guest">
                    <div class="row" style="display: flex;flex-direction: row;">
                        <span style="width: 80px;min-width: 80px;">
                            <span class="grid-content bg-purple">客户编号:</span>
                        </span>
                        <span style="min-width: 300px;">
                            <span class="grid-content bg-purple-light"><span>{{ guest_info.guest_bianhao
                                    }}</span></span>
                        </span>
                        <span style="width: 80px;min-width: 80px;">
                            <span class="grid-content bg-purple"> 客户姓名:</span>
                        </span>
                        <span style="min-width: 300px;">
                            <span class="grid-content  "><span>{{ guest_info.guest_name }}</span></span>
                        </span>
                        <span style="width: 80px;min-width: 80px;">
                            <span class="grid-content bg-purple"> 手机号:</span>
                        </span>
                        <span style="min-width: 300px;">
                            <span class="grid-content  "><span>{{ guest_info.guest_mob }}</span></span>
                        </span>
                    </div>
                    <div class="row" style="display: flex;flex-direction: row;">
                        <el-col style="width: 80px;min-width: 80px;">
                            <div class="grid-content bg-purple">联系地址:</div>
                        </el-col>
                        <el-col style="min-width: 300px;">
                            <div class="grid-content bg-purple-light"><span>{{ guest_info.guest_addr }}</span></div>
                        </el-col>
                        <el-col style="width: 80px;min-width: 80px;">
                            <div class="grid-content bg-purple"> 身份证号: </div>
                        </el-col>
                        <el-col style="min-width: 300px;">
                            <div class="grid-content  "><span>{{ guest_info.guest_sfz_bianhao }}</span></div>
                        </el-col>
                        <el-col style="width: 80px;min-width: 80px;">
                            <div> 客户备注</div>
                        </el-col>
                        <el-col style="min-width: 300px;">
                            <div class="grid-content  "><span>{{ guest_info.guest_memo }}</span></div>
                        </el-col>
                    </div>

                    <div style="height: 1px;background-color: #6d6c6c;"></div>
                    <div class="row" style="display: flex;flex-direction: row;">
                        <el-col style="width: 80px;min-width: 80px;">
                            <div class="grid-content bg-purple">现金账户:</div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content bg-purple-light  " style="width: 180px;min-width: 180px;"><span>{{
                guest_info.guest_yue }}</span></div>
                        </el-col>
                        <el-col style="width: 80px;min-width: 80px;">
                            <div class="grid-content bg-purple  "> 保养账户:</div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content bg-purple-light " style="width: 180px;min-width: 180px;"><span>{{
                guest_info.guest_accout_baoyang
            }}</span>
                            </div>
                        </el-col>
                        <el-col style="width: 80px;min-width: 80px;">
                            <div class="grid-content bg-purple  "> 机油账户:</div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content bg-purple-light " style="width: 180px;min-width: 180px;"><span>{{
                guest_info.guest_accout_jiyou }}</span>
                            </div>
                        </el-col>
                        <el-col style="width: 80px;min-width: 80px;">
                            <div class="grid-content bg-purple  "> 洗车账户:</div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content  bg-purple-light" style="width: 180px;min-width: 180px;"><span>{{
                guest_info.guest_accout_xiche }}</span>
                            </div>
                        </el-col>
                    </div>

                </div>

                <el-card style="margin-top: 30px;background-color: #dee; " width="1440">
                    <div><span style="background-color: #ddd;width: 100%;padding-bottom: 10px;"> 订单编号：{{
                order_info_xianshi.order_bianhao }} 订单备注: {{ order_info_xianshi.order_memo }}
                        </span></div>
                    <div class="print-only">
                        --------------------------------------------------------------------------------------------------------
                    </div>
                    <div class="table" style="max-width: 1000px;background-color: #000;">
                        <el-table ref="multipleTable" :data="order_info_xianshi.chuku_pro_list" tooltip-effect="dark"
                            :default-sort="{ prop: 'xuhao', order: 'descending' }">
                            <!-- :cell-style="tableCellStyle" :header-cell-style="tableCellStyle"  -->
                            <el-table-column label="序号">
                                <template slot-scope="scope">{{ scope.$index
                                    }}</template>
                            </el-table-column>
                            <el-table-column prop="pro_uid" label="商品序号" style="text-align: left;">
                            </el-table-column>
                            <el-table-column prop="pro_name" label="商品名称"> </el-table-column>
                            <el-table-column label="商品类别">
                                <template slot-scope="scope">{{ scope.row.chexing01 }}</template>
                            </el-table-column>
                            <el-table-column prop="pro_count" label="商品数量" show-overflow-tooltip></el-table-column>
                            <el-table-column label="商品价格" prop="pro_price" show-overflow-tooltip>
                                <template slot-scope="scope2">{{ scope2.row.pro_price.toFixed(2)
                                    }}</template>
                            </el-table-column>

                            <el-table-column label="单项总价" show-overflow-tooltip>
                                <template slot-scope="scope2">{{ (scope2.row.pro_count *
                scope2.row.pro_price).toFixed(2)
                                    }}</template></el-table-column>

                        </el-table>
                    </div>
                    <div class="print-only" style="margin-top: 50px;">
                        --------------------------------------------------------------------------------------------------------
                    </div>

                    <div class="print-only">{{ qiyeName
                        }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;电话：{{ userPhone }}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;打印日期：{{ nowDate }}&nbsp;&nbsp;{{
                nowTime }} </div>
                    <div class="shoukuan" v-if="diaoyongType === 3">
                        <div style="text-align: left;font-weight: 400;margin-right: 10px;">
                            模式选择:<el-radio-group v-model="order_jiesuan_type" style="margin-left: 10px;"
                                @change="radioChange">
                                <el-radio :label="5">现金支付</el-radio>
                                <el-radio :label="1">会员账户[¥{{ guest_info.guest_yue }}]</el-radio>
                                <el-radio :label="2">保养卡账户[¥{{ guest_info.guest_accout_baoyang }}]</el-radio>
                                <el-radio :label="3">机油卡账户[¥{{ guest_info.guest_accout_jiyou }}]</el-radio>
                                <el-radio :label="4">洗车卡账户[¥{{ guest_info.guest_accout_xiche }}]</el-radio>
                                <el-radio :label="6">第三方平台核销</el-radio>
                                <el-select v-model="order_laiyuan" placeholder="请选择客户来源"
                                    v-if="order_jiesuan_type === 6">
                                    <el-option v-for="item in guestLy_options" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>

                            </el-radio-group>
                            <span style="color:brown;" v-if="orderDikou_info.youhui_show_flag === true">
                                抵扣后优惠：</span><el-input v-model="orderDikou_info.order_youhui" placeholder="输入优惠金额"
                                style="font-size: larger;width: 150px;" v-if="orderDikou_info.youhui_show_flag === true"
                                @input="youhuiScan"></el-input>
                        </div>
                        <div style="height: 1px;background: #000;"></div>
                        <div style="text-align: left;font-weight: 400;">
                            订单总额合计： <span style="color: red;">{{ order_info_xianshi.order_money }}</span> 元
                            可抵扣<span style="color: red;">{{ order_info_xianshi.order_money_dikou }}</span> 元
                            <span style="color:brown;"> 抵扣后优惠：</span><span style="color: red;">{{
                orderDikou_info.order_youhui }}</span> 元
                            剩余部分支付：<span style="color: red;">{{ order_info_xianshi.order_money_shengyu }}</span> 元

                        </div>
                    </div>
                    <div class="shoukuan" v-if="diaoyongType === 4">

                        <div style="height: 1px;background: #000;"></div>
                        <div style="text-align: left;font-weight: 400;margin-right: 10px;">
                            抵扣模式: <span style="color: red;">
                                {{ order_info_xianshi.order_jiesuan_type === 1 ? '会员账户' : '' }}
                                {{ order_info_xianshi.order_jiesuan_type === 2 ? '保养卡账户' : '' }}
                                {{ order_info_xianshi.order_jiesuan_type === 3 ? '机油卡账户' : '' }}
                                {{ order_info_xianshi.order_jiesuan_type === 4 ? '洗车卡账户' : '' }}
                                {{ order_info_xianshi.order_jiesuan_type === 5 ? '现金支付' : '' }}
                                {{ order_info_xianshi.order_jiesuan_type === 6 ? '第三方平台' : '' }}</span>
                            订单总额合计： <span style="color: red;">{{ order_info_xianshi.order_money }}</span> 元
                            可抵扣<span style="color: red;">{{ order_info_xianshi.order_money_dikou}}</span> 元
                            抵扣后优惠：<span style="color: red;">{{ order_info_xianshi.order_youhui }}</span> 元
                            剩余部分支付：<span style="color: red;">{{ order_info_xianshi.order_money_shengyu }}</span> 元
                        </div>
                    </div>

                </el-card>
            </div>
        </el-card>
    </div>
</template>
<script>
import printJS from 'print-js'
import exportExcel from '../config/exportExcel'
function printHTML(id) {
    const html = document.querySelector('#' + id).innerHTML
    // 新建一个 DOM
    const div = document.createElement('div')
    const printDOMID = 'printDOMElement'
    div.id = printDOMID
    div.innerHTML = html

    // 提取第一个表格的内容 即表头
    const ths = div.querySelectorAll('.el-table__header-wrapper th')
    const ThsTextArry = []
    for (let i = 0, len = ths.length; i < len; i++) {
        if (ths[i].innerText !== '') ThsTextArry.push(ths[i].innerText)
    }

    // 删除多余的表头
    div.querySelector('.hidden-columns').remove()
    // 第一个表格的内容提取出来后已经没用了 删掉
    div.querySelector('.el-table__header-wrapper').remove()

    // 将第一个表格的内容插入到第二个表格
    let newHTML = '<tr>'
    for (let i = 0, len = ThsTextArry.length; i < len; i++) {
        newHTML += '<td style="text-align: center; font-weight: bold">' + ThsTextArry[i] + '</td>'
    }

    newHTML += '</tr>'
    div.querySelector('.el-table__body-wrapper table').insertAdjacentHTML('afterbegin', newHTML)
    // 将新的 DIV 添加到页面 打印后再删掉
    document.querySelector('body').appendChild(div)

    printJS({
        printable: printDOMID,
        type: 'html',
        scanStyles: false,
        style: `@media print{
  
   
        }` // 表格样式
    })
    div.remove()
}
export default {
    props: ['orderInfo', 'diaoyongType'],
    data() {
        return {
            order_jiesuan_type: 0,
            order_laiyuan: 0, // 订单来源
            order_info_xianshi: {},
            data_order: {}, // 总的数据
            cheliang_info: {},
            waiguan_info: {},
            guest_info: {},
            order_info: {},
            chukudan_info: {},

            guestLy_options: [
                {
                    value: 1,
                    label: '抖音'
                },
                {
                    value: 2,
                    label: '美团'
                },
                {
                    value: 3,
                    label: '自然到店'
                },
                {
                    value: 4,
                    label: '邀约'
                },
                {
                    value: 5,
                    label: '转介绍'
                },
                {
                    value: 6,
                    label: '领券'
                },
                {
                    value: 7,
                    label: '其他'
                }
            ],
            orderDikou_info: {
                orderDIkou_money: 0,
                orderDIkou_money_jiyou: 0,
                orderDIkou_money_baoyang: 0,
                orderDIkou_money_xiche: 0,
                order_money: 0,
                orderDIkou_moneyHeji: 0,
                order_money_xuzhifu: 0,
                order_youhui: 0.00, // 抵扣后优惠金额
                youhui_show_flag: false
            },
            userPhone: '',
            qiyeName: '',
            nowDate: new Date().toLocaleDateString('zh-CN'),
            nowTime: new Date().toLocaleTimeString('zh-CN')

        }
    },
    create() {
        // this.data_order = this.orderInfo
        console.log('999', this.userPhone)
    },
    mounted() {
        console.log('返回信息1', this.orderInfo)
        this.getCheliangInfo(this.orderInfo.cheliang_uid)
        this.getWaiguanInfo(this.orderInfo.waiguan_uid)
        this.getGuestInfo(this.orderInfo.guest_uid)
        this.userPhone = window.sessionStorage.getItem('qiye_mob')
        // this.copyright = window.sessionStorage.getItem('copyright')
        this.qiyeName = window.sessionStorage.getItem('qiye_name')
        console.log('this.diaoyongType', this.diaoyongType)
        if (this.diaoyongType === 1) this.order_info_xianshi = this.orderInfo.order_info[0] // 系统管理调用 浏览
        if (this.diaoyongType === 2) this.order_info_xianshi = this.orderInfo.order_info // 开单调用
        if (this.diaoyongType === 3 || this.diaoyongType === 4) this.order_info_xianshi = this.orderInfo // 结算调用
        // diaoyongType 1 浏览调用 2 开单
        console.log('order_info', this.order_info_xianshi)
        // 因为订单不是实时保存数据库，递交才保存，所以 只有当查询管理调用的时候，从数据库，否则，直接在数组变量中读取
        // if (this.diaoyongType === 2)  this.getChukudanInfo(this.data.chukudan_uid)
    },
    methods: {
        tableCellStyle() {
            return 'border-color: black; height:50px;border:1px solid;padding:3px;margin:4px;'
        },
        print_query() {
            // document.getElementById('div').print()
            // window.print()
            printHTML('printMe')
            // printJS({
            //     printable: 'printMe',
            //     type: 'html',
            //     targetStyle: ['*'],
            //     targetStyles: ['*'],
            //     scanStyles: false,
            //     style: this.tableCellStyle(),
            //     maxWidth: 1000
            // })
        },
        handleExport() {
            exportExcel('reportMain', '导出.xlsx')
        },
        async getCheliangInfo(uid) {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_table_name: 'cheliang_info', uid: uid, C_type: 'get_info' }
            });
            // console.log(JSON.parse(res.data))
            // console.log(res.data);
            if (JSON.parse(res.data)[0].status !== 200) {
                return this.$message.error('读取失败');
            }
            // console.log(706, JSON.parse(res.data)[0])
            this.cheliang_info = JSON.parse(res.data)[0].data[0]
        },
        async getWaiguanInfo(uid) {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_table_name: 'waiguan_info', uid: uid, C_type: 'get_info' }
            });
            // console.log(JSON.parse(res.data))
            // console.log(res.data);
            if (JSON.parse(res.data)[0].status !== 200) {
                return this.$message.error('读取失败');
            }
            // console.log(706, JSON.parse(res.data)[0])
            this.waiguan_info = JSON.parse(res.data)[0].data[0]
        },
        async getGuestInfo(uid) {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_table_name: 'guest_info', uid: uid, C_type: 'get_info' }
            });
            // console.log(JSON.parse(res.data))
            // console.log(res.data);
            if (JSON.parse(res.data)[0].status !== 200) {
                return this.$message.error('读取失败');
            }
            // console.log(706, JSON.parse(res.data)[0])
            this.guest_info = JSON.parse(res.data)[0].data[0]
        },
        async getChukudanInfo(uid) {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_table_name: 'chukudan_info', uid: uid, C_type: 'get_info' }
            });
            // console.log(JSON.parse(res.data))
            // console.log(res.data);
            if (JSON.parse(res.data)[0].status !== 200) {
                return this.$message.error('读取失败');
            }
            // console.log(706, JSON.parse(res.data)[0].data[0])
            this.chukudan_info = JSON.parse(res.data)[0].data[0]
        },
        selectPayType(callback) {
            var errFlag = 0
            var data = {}
            var flag = 0
            if (this.diaoyongType !== 3) flag = 1
            console.log(88809, this.orderDikou_info.order_youhui === '')
            if (this.orderDikou_info.order_youhui === '') flag = 2
            if (this.youhuiScan() === 1) flag = 3 // 不是结算模式无需检测
            // 检测优惠输入项目
            if (this.order_jiesuan_type === 0) flag = 3
            if (flag !== 0) { // 说明没有选择
                if (flag === 1) this.$message.error('请选择结算模式！')
                if (flag === 2) this.$message.error('请输入优惠金额！')
                // if (flag === 3) this.$message.error('请输入优惠金额！')
                errFlag = 1
                data = {}
                callback(errFlag, data)
            } else {
                if ((this.order_jiesuan_type === 6) && (this.order_laiyuan === 0)) {
                    this.$message.error('请选择订单来源')
                    errFlag = 1
                    data = {}
                    callback(errFlag, data)
                    return
                }
                errFlag = 0
                data = this.order_info_xianshi
                // 如果已经选择，返回数据集合 
                callback(errFlag, data)
            }
        },
        // 进行数据库递交计算，然后返回结果，返回部分信息如下
        // 每个账户，实际抵扣合计，总金额，总抵扣合计  
        async radioChange() {
            // 类型选择改变，需要重新进行计算剩余现金余额部分 

            const orderJiesuanForm = {
                C_type: 'orderMoneyJiesuan',
                order_uid: this.order_info_xianshi.uid,
                jiesuan_type: this.order_jiesuan_type,
                // order_laiyuan: this.order_laiyuan,
                guest_uid: this.order_info_xianshi.guest_uid
            }
            const { data: res } = await this.$http.post('api', orderJiesuanForm);
            if (JSON.parse(res.data)[0].status !== 200) {
                return this.$message.error('读取失败');
            }
            this.orderDikou_info.orderDIkou_money = JSON.parse(res.data)[0].orderDIkou_money.toFixed(2)
            this.orderDikou_info.orderDIkou_money_jiyou = JSON.parse(res.data)[0].orderDIkou_money_jiyou.toFixed(2)
            this.orderDikou_info.orderDIkou_money_baoyang = JSON.parse(res.data)[0].orderDIkou_money_baoyang.toFixed(2)
            this.orderDikou_info.orderDIkou_money_xiche = JSON.parse(res.data)[0].orderDIkou_money_xiche.toFixed(2)
            this.orderDikou_info.order_money = JSON.parse(res.data)[0].order_money.toFixed(2)
            this.orderDikou_info.orderDIkou_moneyHeji = JSON.parse(res.data)[0].orderDIkou_moneyHeji.toFixed(2)
            this.orderDikou_info.order_money_xuzhifu = JSON.parse(res.data)[0].order_money_xuzhifu.toFixed(2)
            // order_info_xianshi 由props 传递 --> jiesuan_add -->orderList传递 --》读取数据库生成

            // 直接通过回调函数返回参数 
            this.youhuiScan()
        },
        youhuiScan() {
            this.order_info_xianshi.order_money = this.orderDikou_info.order_money
            this.order_info_xianshi.order_money_dikou = this.orderDikou_info.orderDIkou_moneyHeji
            this.order_info_xianshi.order_money_shengyu = this.orderDikou_info.order_money_xuzhifu - parseFloat(this.orderDikou_info.order_youhui)
            this.order_info_xianshi.order_youhui = parseFloat(this.orderDikou_info.order_youhui)
            this.order_info_xianshi.order_jiesuan_type = this.order_jiesuan_type // 结账类型保存传递到数据库
            this.order_info_xianshi.order_laiyuan = this.order_laiyuan // 订单来源
            this.orderDikou_info.youhui_show_flag = true

            console.log(9990, this.orderDikou_info.order_youhui, parseFloat(this.orderDikou_info.order_money_xuzhifu))
            if (this.orderDikou_info.order_youhui) this.orderDikou_info.order_youhui = parseFloat(this.orderDikou_info.order_youhui)
            if ((this.orderDikou_info.order_youhui > parseFloat(this.orderDikou_info.order_money_xuzhifu)) || (this.orderDikou_info.youhui < 0) || (typeof this.orderDikou_info.youhui === 'number')) {
                this.$message('优惠金额填写错误，请重新输入')
                this.orderDikou_info.order_youhui = 0.0
                return 1
            }

            return 0
        }
    }
}
</script>
<style>
.test {
    font-size: 6cqh;
    border: 10px;
    border-color: black;
}

.bg-purple {

    width: 100px;
    font-weight: 600;
    font-size: 13px;
}

.bg-purple-light {
    width: 150px;
    height: 20px;
    text-align: center;
    border-radius: 2px 2px 2px 2px;
    background-color: #999999;
    font-size: 13px;
}

.cheliang {
    display: flex;
    flex: row;
    padding: 10px;
    background-color: #eee;
    height: 80px;
    border-radius: 10px;
    font-size: 13px;
}

.title {
    font-size: 13px;
    font-weight: 450;
    left: 10px;
    margin-top: 20px;
}

.waiguan {
    font-size: 13px;
    padding: 10px;
    background-color: #eee;
    height: 80px;
    border-radius: 10px;
    height: 40px;
}

.guest {
    font-size: 13px;
    padding: 10px;
    background-color: #eee;
    height: 80px;
    border-radius: 10px;
    height: 120px;
}

.row {
    height: 30px;
    margin-top: 5px;
    display: flex;
    flex-direction: row;
}

.shoukuan {
    font-size: 13px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: left;
}

.query_print {
    font-size: 15px;
}

@media print {
    .table {
        width: 90vw !important;
        display: none !important;
    }
}

.table {
    width: 90vw !important;
}

/* 默认的屏幕显示样式 */
.print-only {
    display: none;
    /* 在屏幕上隐藏 */
}

/* 打印时的样式 */
@media print {
    .print-only {
        display: block;
        /* 在打印时显示 */
    }

    /* 可以隐藏不需要打印的元素 */
    .no-print {
        display: none;
        /* 在打印时隐藏 */
    }
}
</style>
